import React from 'react';
import { ComponentProps } from '@components';
import propData from './propData';

const Props = pageHref => (
  <ComponentProps pageHref={pageHref} propData={propData} />
);
export default Props;
